import React from 'react';
import { Button } from 'antd';
import s from './s.module.less';
import { useNavigate } from 'react-router-dom';
import { HOME, UNIPROFILE } from 'constants/common';
import useGetUniprofileEntry from 'hooks/useGetUniprofileEntry';

const InitStep: React.FC<{
    className: string;
    isSubmittedUniproile: boolean;
}> = ({ className, isSubmittedUniproile }) => {
    const [uniprofileEntryPath] = useGetUniprofileEntry();
    const navigate = useNavigate();
    return (
        <div className={`${s.wrapper} ${className}`}>
            <div className={s.content}>
                <div className={s.title}>
                    Create your UniProfile
                </div>
                <div className={s.desc}>
                    Your profile is what patients see first—make a strong impression. A complete profile builds trust and increases bookings.
                </div>
                <div className={s.buttonWrap}>
                    {isSubmittedUniproile ? (
                        <Button
                            type="primary"
                            onClick={() => {
                                navigate(`${uniprofileEntryPath}?type=${UNIPROFILE}&from=${HOME}`);
                            }}
                        >
                            Open UniProfile
                        </Button>
                    ) : (
                        <Button
                            type="primary"
                            onClick={() => {
                                navigate(`${uniprofileEntryPath}?type=${UNIPROFILE}`);
                            }}
                        >
                            Create UniProfile
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default InitStep;
